// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as SWR from "../../../../node_modules/rescript-swr/lib/es6_global/src/SWR.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Js_promise from "../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as RollbarInstance$Showside from "../utils/RollbarInstance.bs.js";
var counter = {
  contents: {}
};
function ErrorReporter(Props) {
  var error = Props.error;
  var displayMessage = Props.displayMessage;
  var extraInfo = Props.extraInfo;
  var retry = Props.retry;
  var redirect = Props.redirect;
  var canRenderOnLiveOpt = Props.canRenderOnLive;
  var absoluteOpt = Props.absolute;
  var reportEvery = Props.reportEvery;
  var canRenderOnLive = canRenderOnLiveOpt !== undefined ? canRenderOnLiveOpt : false;
  var absolute = absoluteOpt !== undefined ? absoluteOpt : false;
  var match = RouterProvider$Showside.useRouter(undefined);
  var previewMode = match.previewMode;
  var isPreviewMode = Caml_obj.notequal(previewMode, /* PreviewLive */1) && previewMode !== undefined;
  var displayMessage$1;
  var exit = 0;
  if (displayMessage !== undefined && (error.RE_EXN_ID === RollbarInstance$Showside.LogicalError || error.RE_EXN_ID === RollbarInstance$Showside.LogicalErrorUnreported)) {
    displayMessage$1 = displayMessage;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    displayMessage$1 = error.RE_EXN_ID === SWR.NetworkError ? "There appears to be a problem with your internet connection" : displayMessage !== undefined || !(error.RE_EXN_ID === RollbarInstance$Showside.LogicalError || error.RE_EXN_ID === RollbarInstance$Showside.LogicalErrorUnreported) ? "An unexpected error has occurred." : error._1;
  }
  var getCount = function (param) {
    return Belt_Option.getWithDefault(Js_dict.get(counter.contents, displayMessage$1), 0);
  };
  var incrementCounter = function (param) {
    if (reportEvery !== undefined) {
      counter.contents[displayMessage$1] = getCount(undefined) >= reportEvery ? 0 : getCount(undefined) + 1 | 0;
      return;
    }
  };
  React.useEffect(function () {
    var currentCount = getCount(undefined);
    incrementCounter(undefined);
    console.error(error);
    if (isPreviewMode) {
      return;
    }
    if (error.RE_EXN_ID === SWR.NetworkError || error.RE_EXN_ID === RollbarInstance$Showside.LogicalErrorUnreported || !(error.RE_EXN_ID === RollbarInstance$Showside.LogicalError && currentCount === 0)) {
      Promise.resolve(undefined);
    } else {
      RollbarInstance$Showside.error3(error, error._1, extraInfo);
    }
    var timeout = redirect !== undefined ? Caml_option.some(setTimeout(function (param) {
      Curry._1(redirect, undefined);
    }, 0)) : undefined;
    return function (param) {
      Belt_Option.forEach(timeout, function (id) {
        clearTimeout(id);
      });
    };
  }, []);
  var match$1 = React.useState(function () {
    return false;
  });
  var setRetrying = match$1[1];
  var retrying = match$1[0];
  var onClickRetry = Belt_Option.map(retry, function (retry, param) {
    Curry._1(setRetrying, function (param) {
      return true;
    });
    var __x = Curry._1(retry, undefined);
    var __x$1 = Js_promise.then_(function (param) {
      Curry._1(setRetrying, function (param) {
        return false;
      });
      return Promise.resolve(undefined);
    }, __x);
    Js_promise.$$catch(function (param) {
      Curry._1(setRetrying, function (param) {
        return false;
      });
      return Promise.resolve(undefined);
    }, __x$1);
  });
  var renderRetry = function (param) {
    return Belt_Option.mapWithDefault(onClickRetry, null, function (onClickRetry) {
      return React.createElement("button", {
        className: CSS$Showside.prefix(Cn.make(["text-gray-800 px-2 py-1 border border-solid border-gray-200", retrying ? "bg-gray-300" : "bg-white"])),
        disabled: retrying,
        onClick: function (param) {
          Curry._1(onClickRetry, undefined);
        }
      }, "Retry");
    });
  };
  var renderExit = function (param) {
    if (redirect !== undefined) {
      return React.createElement("button", {
        className: CSS$Showside.prefix(Cn.make(["text-gray-800 px-2 py-1 border border-solid border-gray-200 bg-white"])),
        onClick: function (param) {
          Curry._1(redirect, undefined);
        }
      }, "Back");
    } else {
      return null;
    }
  };
  if (isPreviewMode || canRenderOnLive) {
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make([absolute ? "absolute inset-0" : "relative", "flex flex-col items-center justify-center bg-gray-50 text-gray-800 space-y-6"]))
    }, React.createElement("div", {
      className: CSS$Showside.prefix("flex items-center justify-center h-12 w-12 rounded-full bg-white-200 text-gray-500")
    }, React.createElement(Unicons$Showside.UilExclamationTriangle.make, {})), React.createElement("div", undefined, displayMessage$1), React.createElement("div", {
      className: CSS$Showside.prefix("space-x-4")
    }, renderRetry(undefined), renderExit(undefined)), canRenderOnLive ? null : React.createElement("div", {
      className: CSS$Showside.prefix("mt-8 text-sm justify-center text-center")
    }, React.createElement("div", undefined, "Customers will never see this page."), React.createElement("div", undefined, "It is only visible in preview.")));
  } else {
    return null;
  }
}
ErrorReporter.displayName = "ErrorReporter";
var make = ErrorReporter;
export { counter, make };
/* SWR Not a pure module */